
/*------------------------------------------
 * 7. Image Lazyload Compatibility
-------------------------------------------*/
(function(window, document) {
    'use strict';

    var config = window.lazySizesConfig || window.lazysizesConfig || {};
    var scanTimer = null;
    var observer = null;

    function fire(element, name) {
        var event;

        if (typeof window.CustomEvent === 'function') {
            event = new CustomEvent(name, {
                bubbles: false,
                cancelable: true,
                detail: {instance: window.lazySizes}
            });
        } else {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(name, false, true, {instance: window.lazySizes});
        }

        return element.dispatchEvent(event);
    }

    function getRootMargin() {
        if (typeof config.expand === 'number') {
            return config.expand + 'px 0px';
        }

        if (typeof config.expand === 'string') {
            return config.expand;
        }

        return '700px 0px';
    }

    function setImageSource(element) {
        var src = element.getAttribute('data-src');
        var srcset = element.getAttribute('data-srcset');
        var sizes = element.getAttribute('data-sizes');
        var bg = element.getAttribute('data-bg');
        var tag = element.nodeName.toLowerCase();
        var parent = element.parentNode;
        var sources;

        if (sizes && element.getAttribute('sizes') !== sizes) {
            element.setAttribute('sizes', sizes);
        }

        if (tag === 'img' && parent && parent.nodeName && parent.nodeName.toLowerCase() === 'picture') {
            sources = parent.querySelectorAll('source[data-srcset], source[data-src]');
            Array.prototype.forEach.call(sources, function(source) {
                var sourceSrcset = source.getAttribute('data-srcset') || source.getAttribute('data-src');
                var sourceSizes = source.getAttribute('data-sizes');

                if (sourceSizes && source.getAttribute('sizes') !== sourceSizes) {
                    source.setAttribute('sizes', sourceSizes);
                }

                if (sourceSrcset && source.getAttribute('srcset') !== sourceSrcset) {
                    source.setAttribute('srcset', sourceSrcset);
                }
            });
        }

        if (srcset && element.getAttribute('srcset') !== srcset) {
            element.setAttribute('srcset', srcset);
        }

        if (src) {
            if (tag === 'source' && element.getAttribute('srcset') !== src) {
                element.setAttribute('srcset', src);
            } else if (tag !== 'source' && element.getAttribute('src') !== src) {
                element.setAttribute('src', src);
            }
        }

        if (bg && !element.style.backgroundImage) {
            element.style.backgroundImage = 'url("' + bg.replace(/"/g, '\\"') + '")';
        }
    }

    function unveil(element) {
        if (!element || element.nodeType !== 1) {
            return;
        }

        if (element.classList.contains('lazyloaded')) {
            return;
        }

        if (observer) {
            observer.unobserve(element);
        }
        element._hmLazyObserved = false;

        fire(element, 'lazybeforeunveil');
        setImageSource(element);
        element.classList.remove('lazyload');
        element.classList.remove('lazyloading');
        element.classList.add('lazyloaded');
        fire(element, 'lazyloaded');
    }

    function collect(context) {
        var root = context && context.nodeType === 1 ? context : document;
        var items = [];

        if (root.classList && root.classList.contains('lazyload')) {
            items.push(root);
        }

        return items.concat(Array.prototype.slice.call(root.querySelectorAll('.lazyload')));
    }

    function observe(element) {
        if (!element || element.nodeType !== 1 || element.classList.contains('lazyloaded')) {
            return;
        }

        if (!observer) {
            unveil(element);
            return;
        }

        if (element._hmLazyObserved) {
            return;
        }

        element._hmLazyObserved = true;
        observer.observe(element);
    }

    function scan(context) {
        collect(context).forEach(observe);
    }

    function queueScan(context) {
        if (scanTimer) {
            window.clearTimeout(scanTimer);
        }

        scanTimer = window.setTimeout(function() {
            scanTimer = null;
            scan(context);
        }, 0);
    }

    if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting || entry.intersectionRatio > 0) {
                    unveil(entry.target);
                }
            });
        }, {
            rootMargin: getRootMargin(),
            threshold: 0.01
        });
    }

    window.lazySizesConfig = config;
    window.lazySizes = {
        cfg: config,
        init: scan,
        loader: {
            checkElems: scan,
            unveil: unveil
        },
        autoSizer: {
            checkElems: function() {},
            updateElem: function() {}
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            scan();
        });
    } else {
        queueScan();
    }

    window.addEventListener('load', function() {
        scan();
    });

    if (window.MutationObserver) {
        new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                Array.prototype.forEach.call(mutation.addedNodes, function(node) {
                    if (node.nodeType === 1) {
                        queueScan(node);
                    }
                });
            });
        }).observe(document.documentElement, {childList: true, subtree: true});
    }
})(window, document);
